import React from "react";
import { useSelector } from "react-redux";
import {
  fetchOrdersFilterChipsDisplayCount,
  fetchRoutesFilterChipsDisplayCount,
  fetchPlanningOrderListByFilter,
  fetchPlanningRouteListByFilter,
  publishRoutes,
  deleteRoute,
  clearPublishedRoutesErrors,
  clearUpdatedRoute,
  resetPlanningError,
  resetConsignmentReplanningSuccess,
  fetchDeliveryReasons,
  fetchDynamicFiltersOrdersDropdownValues,
  fetchDynamicFiltersRoutesDropdownValues,
  clearCurrentSlot,
  exportToExcel,
  exportRoutesToExcel,
  resetExportInitiated,
} from "./redux/valetTrolleySlice";

import {
  createDeleteRoutePayload,
  createFilterPayload,
  createPublishRoutesPayload,
  getConsignmentStatusField,
  getRouteStatusField,
  lastMileVTOrdersDataTransform,
  lastMileVTRoutesDataTransform,
  createPayloadForExcelExport,
  createRoutesPayloadForExcelExport,
} from "../mocks/valetTrolley/response.transforms";

//Common Components
import { AppState } from "../config/redux/reducers";

//Constants, Utils
import AppConstants from "../constants";
import UACConstants from "../constants/UACConstants";
import { useUACHelper } from "../contexts/UACContext";

//Components
import ValetTrolleyOrderDetails from "./ValetTrolleyOrderDetails";
import DeliveryBaseComponent from "SharedComponent/components/deliveryComponent";

interface ValetTrolleyProps {
  match?: any;
  location?: any;
}

const ValetTrolley = (props: ValetTrolleyProps) => {
  const { match, location } = props;
  const {
    ordersData,
    routesData,
    tableLoading,
    ordersFiltersDropdowns,
    routesFiltersDropdowns,
    vtOrdersFilterChipsDisplayCount,
    routesFilterChipsDisplayCount,
    publishedRoutes,
    deletedRoute,
    publishedRoutesErrors,
    updatedRoute,
    routeDiscardSuccess,
    vtReplanningConsignmentSuccess,
    isUpdateAddress,
    loading,
    error,
    errorCode,
    exportError,
    excelLoading,
    exportInitiated,
    reportId,
  } = useSelector((state: AppState) => state.valetTrolley);

  const uacHelper = useUACHelper();

  const tabs = React.useMemo(() => {
    const availableTabs = [];

    if (uacHelper.hasAccess(UACConstants.VT_ORDERS)) {
      availableTabs.push({
        key: UACConstants.VT_ORDERS,
        label: "Orders",
        // ...existing tab config...
      });
    }

    if (uacHelper.hasAccess(UACConstants.VT_ROUTES)) {
      availableTabs.push({
        key: UACConstants.VT_ROUTES,
        label: "Routes",
        // ...existing tab config...
      });
    }

    return availableTabs;
  }, [uacHelper]);

  return (
    <DeliveryBaseComponent
      match={match}
      location={location}
      OrderDetailsComponent={ValetTrolleyOrderDetails}
      deliveryState={{
        ordersData,
        routesData,
        tableLoading,
        ordersFiltersDropdowns,
        routesFiltersDropdowns,
        ordersFilterChipsDisplayCount: vtOrdersFilterChipsDisplayCount,
        routesFilterChipsDisplayCount,
        publishedRoutes,
        deletedRoute,
        publishedRoutesErrors,
        updatedRoute,
        routeDiscardSuccess,
        replanningConsignmentSuccess: vtReplanningConsignmentSuccess,
        isUpdateAddress,
        loading,
        error,
        errorCode,
        exportError,
        excelLoading,
        exportInitiated,
        reportId,
      }}
      actions={{
        fetchOrdersFilterChipsDisplayCount,
        fetchRoutesFilterChipsDisplayCount,
        fetchPlanningOrderListByFilter,
        fetchPlanningRouteListByFilter,
        publishRoutes,
        deleteRoute,
        clearPublishedRoutesErrors,
        clearUpdatedRoute,
        resetPlanningError,
        resetConsignmentReplanningSuccess,
        fetchDeliveryReasons,
        fetchDynamicFiltersOrdersDropdownValues,
        fetchDynamicFiltersRoutesDropdownValues,
        clearCurrentSlot,
        exportToExcel,
        exportRoutesToExcel,
        resetExportInitiated,
      }}
      transforms={{
        createDeleteRoutePayload,
        createFilterPayload,
        createPublishRoutesPayload,
        getConsignmentStatusField,
        getRouteStatusField,
        lastMileOrdersDataTransform: lastMileVTOrdersDataTransform,
        lastMileRoutesDataTransform: lastMileVTRoutesDataTransform,
        createPayloadForExcelExport,
        createRoutesPayloadForExcelExport,
      }}
      routePath={{
        createRoute: AppConstants.ROUTES.VALET_TROLLEY_CREATE_ROUTE,
        editRoute: AppConstants.ROUTES.VALET_TROLLEY_EDIT_ROUTE,
        viewRoute: AppConstants.ROUTES.VALET_TROLLEY_VIEW_ROUTE,
      }}
      uacKey={UACConstants.VT_ORDERS}
    />
  );
};

export default ValetTrolley;
